export function routes($stateProvider) {
  $stateProvider
    .state('app.indicadores', {
      url: '/indicadores',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.indicadores.details', {
      url: '',
      title: 'Indicadores',
      controller: 'IndicadoresDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'indicadoresRead'
    })
  ;
}

routes.$inject = ['$stateProvider'];
